import { conditions } from "helpers"
import { ConditionName } from "interfaces"
import { toast } from "mobin-toast"
import { setBookmarksPopover } from "redux-share/slices/popoversSlice"
import BookmarkIcon from "../../icon-components/bookmarkIcon"
import ProfileIcon from "../../icon-components/ProfileIcon"
import { useAppDispatch, useAppSelector } from "redux-share"
import HomeIcon from "../../icon-components/homeIcon"
import { shallowEqual } from 'react-redux'

const TabNavigator = () => {

    const dispatch = useAppDispatch();
    useAppSelector(({ popovers: { bookmarksPopover } }) => ({ bookmarksPopover }), shallowEqual);

    return (
        <div className="pl-fixed pl-bottom-4 pl-w-full">
            <div
                className="pl-flex pl-justify-around pl-items-center pl-py-3 pl-bg-white dark:pl-bg-dark-1 pl-border pl-border-secondary-200 dark:pl-border-z-gray-700 pl-text-[12px] pl-font-normal pl-rounded-[12px]"
                style={{ boxShadow: conditions(ConditionName.isDarkMode) ? "0px 4px 4px 0px #312F2E" : "0px 4px 4px 0px rgba(160, 163, 189, 0.88)", margin: "0px 24px" }}
            >
                <div
                    className={`pl-flex pl-flex-col pl-items-center pl-gap-[3px] pl-px-[25px] pl-py-[3px] ${conditions(ConditionName.showBookmarksPopover) ? "pl-bg-main-lightPurple dark:pl-bg-main pl-text-main dark:pl-text-white pl-rounded-[4px]" : "pl-text-z-gray-500 dark:pl-text-z-secondary-50"}`}
                    onClick={() => {
                        if (conditions(ConditionName.isLogin)) dispatch(setBookmarksPopover(true))
                        else toast({ title: "لطفا ابتدا وارد شوید.", type: "error" })
                    }}
                >
                    <BookmarkIcon className={`${conditions(ConditionName.showBookmarksPopover) ? "pl-fill-main dark:pl-fill-white" : "pl-fill-z-gray-500 dark:pl-fill-z-secondary-50"}`} type="double" />
                    <p className="pl-text-[11px] pl-font-normal">ذخیره‌شده‌ها</p>
                </div>
                <div className={`pl-flex pl-flex-col pl-items-center pl-gap-[3px] pl-px-[25px] pl-py-[3px] pl-rounded-[4px] ${conditions(ConditionName.showBookmarksPopover) ? "pl-text-z-gray-500 dark:pl-text-z-secondary-50" : "pl-bg-main-lightPurple dark:pl-bg-main pl-text-main dark:pl-text-white"}`} onClick={() => dispatch(setBookmarksPopover(false))}>
                    <HomeIcon className={`${conditions(ConditionName.showBookmarksPopover) ? "pl-fill-z-gray-500 dark:pl-fill-z-secondary-50" : "pl-fill-main dark:pl-fill-white"}`} />
                    <p className="pl-text-[11px] pl-font-normal">خانه</p>
                </div>
                <div className="pl-flex pl-flex-col pl-items-center pl-gap-[3px] pl-px-[25px] pl-py-[3px]" onClick={() => window.location.href = "zarebinlite://profile"}>
                    <ProfileIcon className="pl-w-5 pl-h-5 pl-fill-dark-1 dark:pl-fill-dark-6" />
                    <p className="pl-text-[11px] pl-font-normal pl-text-z-gray-500 dark:pl-text-z-secondary-50">پروفایل</p>
                </div>
            </div>
        </div>
    )
}

export default TabNavigator;